import React from 'react'
import { permitsList, generalTitles } from '@auteco/constants'
import TableType2 from 'src/components/sharedComponents/Tablas/TableType2/TableType2'
import CardTitle from 'src/components/sharedComponents/CardTitle'

const BuggetsPage = ({
  loading,
  budgets = [],
  permisos,
  onUpdate,
  columns,
}) => (
  <>
    <CardTitle title={generalTitles.TITLE_CARD_BUDGETS} />
    <TableType2
      dataTable={budgets}
      idPermiso={permitsList.PRESUPUESTOS_COMERCIALES}
      onUpdate={onUpdate}
      minValue={permisos[permitsList.PRESUPUESTOS_COMERCIALES]}
      columns={columns}
      loading={loading}
    />
  </>
)

export default BuggetsPage
